export const EXABORGANIZATIONLEAD_SHOW_RESET = 'EXABORGANIZATIONLEAD_SHOW_RESET'
export const EXABORGANIZATIONLEAD_SHOW_SET_ERROR = 'EXABORGANIZATIONLEAD_SHOW_SET_ERROR'
export const EXABORGANIZATIONLEAD_SHOW_SET_RETRIEVED = 'EXABORGANIZATIONLEAD_SHOW_SET_RETRIEVED'
export const EXABORGANIZATIONLEAD_SHOW_TOGGLE_LOADING = 'EXABORGANIZATIONLEAD_SHOW_TOGGLE_LOADING'
